import { useEffect, useState } from 'react';

import {
  ensureAccountUnlockLoaded,
  isWalletSessionUnlocked as isWalletSessionUnlockedAsync,
} from '../lib/mpcUnlockCache';

/** React hook: account payment password unlocked for the current login session. */
export function useWalletSessionUnlocked(_walletId?: number): boolean {
  const [unlocked, setUnlocked] = useState(false);

  useEffect(() => {
    let active = true;
    const refresh = () => {
      void isWalletSessionUnlockedAsync().then((v: boolean) => {
        if (active) {
          setUnlocked(v);
        }
      });
    };
    refresh();
    const onChange = () => refresh();
    window.addEventListener('cointrader-mpc-unlock-changed', onChange);
    return () => {
      active = false;
      window.removeEventListener('cointrader-mpc-unlock-changed', onChange);
    };
  }, [_walletId]);

  return unlocked;
}

export { ensureAccountUnlockLoaded };
